var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrategies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5524 23.5C46.5524 36.2315 36.2315 46.5524 23.5 46.5524C10.7685 46.5524 0.447619 36.2315 0.447619 23.5C0.447619 10.7685 10.7685 0.447619 23.5 0.447619C36.2315 0.447619 46.5524 10.7685 46.5524 23.5Z",
    fill: "none",
    stroke: "#3B4443",
    strokeWidth: 0.895238
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1157 6.88354L6.88281 40.1165",
    stroke: "#3B4443",
    strokeWidth: 0.895238
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 23.5V47",
    stroke: "#3B4443",
    strokeWidth: 0.895238
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.166 7.83325V41.0148",
    stroke: "#3B4443",
    strokeWidth: 0.895238
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.334 15.6666V45.6609",
    stroke: "#3B4443",
    strokeWidth: 0.895238
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.666 31.3334V45.661",
    stroke: "#3B4443",
    strokeWidth: 0.895238
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategies);
export default __webpack_public_path__ + "static/media/strategies.208d7634c3a3ae98377bfbc3996c6df3.svg";
export { ForwardRef as ReactComponent };